import { render, staticRenderFns } from "./RightPanelDetails.vue?vue&type=template&id=27e910fe&scoped=true&"
import script from "./RightPanelDetails.vue?vue&type=script&lang=js&"
export * from "./RightPanelDetails.vue?vue&type=script&lang=js&"
import style0 from "./RightPanelDetails.vue?vue&type=style&index=0&id=27e910fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e910fe",
  null
  
)

export default component.exports